export default __webpack_public_path__ + "static/2-629fb4e78d32397fe7d5f2966900a547.webp";